export interface IOAuthConfig {
    AuthServerUri: string;
    AuthPath: string;
    TokenPath: string;
    ClientId: string;
    ReturnUri: string;
    UserInfoPath: string;
    SignoutPath: string;
    Nonce: string;
    Scope: string;
}

export interface IOAuthToken {
    access_token: string,
    expires_in: string,
    state: string,
    token_type: string
}

export interface IUserInfo {
    Email: string;
    FirstName: string;
    LastName: string;
    Id: string;
    PersonDetailsId?: string;
    Rights: string[];
    Roles: string[];
    UserType: string;
    UserName: string;
    Impersonator?: IUserInfo;
}

export enum UserType {
    Student = 'Student',
    Employee = 'Employee'
}

export class User {
    id: string;
    email: string;
    username: string;
    firstName: string;
    lastName: string;
    roles: string[] = [];
    rights: string[] = [];
    type?: UserType;
    personDetailsId?: string;
    impersonator: User;

    get isStudent(): boolean {
        return this.hasRole('student');
    }

    get isAdmin(): boolean {
        return this.hasRole('administrator');
    }

    get isAnonymous(): boolean {
        return this.hasRole('anonymous');
    }

    get isImpersonator(): boolean {
        return this.hasRight('ES_MAIN.IMPERSONATION.SET');
    }

    hasRole(role: string): boolean {
        if (!role) return false;

        const found = this.roles.find((r) => { return r.toLowerCase() === role.toLowerCase() });
        return (found != null && found != '');
    }

    hasRight(right: string): boolean {
        if (!right) return false;

        const found = this.rights.find((r) => { return r.toLowerCase() === right.toLowerCase() });
        return (found != null && found != '');
    }
}

export class UserCrypto {
    key: string;
    iv: string;
}
